<script lang="ts">
  import { defineComponent } from "vue";
  import FicheTransactionSalarie from '@/generated/fiches/FicheTransactionSalarie.vue';
  export default defineComponent({
    extends: FicheTransactionSalarie,
    components: {}
})
</script>
